import React from "react";
import { fmtInt, type Origen, type OrigenCounts } from "../sandbox/resumenData";
import type { SandboxTheme } from "../sandbox/SandboxResumen";

const OPCIONES: [Origen, string][] = [
  ["all", "Todo"],
  ["organic", "Orgánico"],
  ["paid", "Anuncios"],
];

interface Props {
  theme: SandboxTheme;
  origen: Origen;
  counts: OrigenCounts;
  onChange: (origen: Origen) => void;
  disabled?: boolean;
}

/** Control segmentado de origen para el teléfono: tres opciones de 48 px con su conteo. */
export function SocialOrigenSelectorMobile({ theme, origen, counts, onChange, disabled = false }: Props) {
  return (
    <div className="sbx sbx-origen-m" data-theme={theme}>
      <div className="seg" role="radiogroup" aria-label="Origen de los comentarios" aria-disabled={disabled || undefined}>
        {OPCIONES.map(([id, label]) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={origen === id}
            disabled={disabled}
            data-testid={`origen-${id}`}
            data-count={counts[id]}
            onClick={() => onChange(id)}
          >
            <span>{label}</span>
            <small>{fmtInt(counts[id])}</small>
          </button>
        ))}
      </div>
      {disabled && <p className="hint">Los mensajes directos no se separan por origen</p>}
    </div>
  );
}
